import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { HomeComponent} from './component/home/home.component';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  { path: 'sign-in', component: SignInComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'device', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'device/:userid/:businessprofileid', component: HomeComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  { path: '**', component: SignInComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
